import React, { Component } from 'react'

import Typeahead from '../components/Typeahead'
import Field from '../components/Field'
import NumberField from '../components/NumberField'
import SelectField from '../components/Select'
import Traffic from '../components/TrafficSources'
import TextArea from '../components/TextArea'
import CheckboxGroup from '../components/CheckboxGroup'
import DateField from '../components/DateField'
import TrafficRow from '../components/TrafficRow'

class BuildForm extends Component {
    constructor(props) {
        super(props)

    }


    buildField = (r) => {
        var field = ''
        switch(r.type) {
            case 'typeahead':
                field = <Typeahead editing={this.props.editing} value={r.value} ep={r.ep} label={r.label} id={r.id} ref={r.id} useID={r.useID} valid={r.validate} setValid={this.props.setValid} updateValue={this.props.updateValue} />
                break
            case 'number':
                field = <NumberField editing={this.props.editing} value={r.value} id={r.id} type="text" label={r.label} ref={r.id} valid={r.validate} thousandSeparator={r.comma} prefix={r.prefix} mask={r.mask} format={r.format} setValid={this.props.setValid} updateValue={this.props.updateValue} />
                break
            case 'select':
                field = <SelectField editing={this.props.editing} value={r.value} id={r.id} label={r.label} ref={r.id} valid={r.validate} options={r.options} setValid={this.props.setValid} updateValue={this.props.updateValue} />
                break
            case 'trafficsources':
                field = <Traffic editing={this.props.editing} value={r.value} id={r.id} label={r.label} ref={r.id} valid={r.validate} options={r.options} setValid={this.props.setValid} updateValue={this.props.updateValue} />
                break
            case 'checkbox':
                field = <CheckboxGroup editing={this.props.editing} value={r.value} id={r.id} label={r.label} type={r.type} ref={r.id} valid={r.validate} options={r.options} setValid={this.props.setValid} updateValue={this.props.updateValue} />
                break
            case 'textarea':
                field = <TextArea editing={this.props.editing} value={r.value} id={r.id} label={r.label} ref={r.id} valid={r.validate} setValid={this.props.setValid} updateValue={this.props.updateValue} />
                break
            case 'date':
                field = <DateField editing={this.props.editing} value={r.value} id={r.id} label={r.label} ref={r.id} valid={r.validate} setValid={this.props.setValid} updateValue={this.props.updateValue} />
                break
            case 'traffic':
                field = <TrafficRow editing={this.props.editing} value={r.value} id={r.id} label={r.label} ref={r.id} valid={r.validate} setValid={this.props.setValid} updateValue={this.props.updateValue} removeRow={this.props.removeRow} />
                break
            default:
                field = <Field editing={this.props.editing} value={r.value} id={r.id} type={r.type} label={r.label} ref={r.id} setValid={this.props.setValid} updateValue={this.props.updateValue} valid={r.validate} />
        }

        return field
    }

    renderFields = () => {
        return this.props.fields.map((r, i) => {
            var field = ''
            field = this.buildField(r)
            return (
                <li className="form__listItem" key={i}>
                    {field}
                </li>
            )            
        })
    }
    

    render() {
        return(
            <div>
                {this.renderFields()}
            </div>
        )
    }
}

export default BuildForm